import React from 'react';
import { useTranslation } from 'react-i18next';
import { emailLogType } from '../../types';
import DateTime, { LONG_DATETIME } from '../DateTime';
import './_styles_/EmailLogRow.css';

EmailLogRow.propTypes = {
    emailLog: emailLogType.isRequired,
};

function EmailLogRow(props) {
    const {
        emailLog,
    } = props;
    const { t } = useTranslation();
    const statusClassName = emailLog.status === 'FAILED'
        ? 'email-log-header--values--status readonly email-log--status-failed'
        : 'email-log-header--values--status readonly';
    return (
        <div className="rich-list-row email-log-header">
            <div className="email-log-header--values--date-time readonly"><DateTime value={emailLog.dateTime} format={LONG_DATETIME} /></div>
            <div className="email-log-header--values--subject readonly">{emailLog.subject}</div>
            <div className="email-log-header--values--recipients readonly">{emailLog.recipients}</div>
            <div className={statusClassName}>{t(`email-logs.status.${emailLog.status}`)}</div>
            <div className="email-log-header--values--user-id readonly">{emailLog.userId}</div>
        </div>
    );
}

export default EmailLogRow;
